import { Component } from "@angular/core";

@Component({
    selector: "cefi-connections-list-page",
    templateUrl: "./connections-list-page.component.html",
    styleUrls: ["./connections-list-page.component.scss"],
})
export class ConnectionsListPageComponent {}
